import React from "react";

import QrCodeWrap from "./qrCode.style";

export default function QrCode() {
  return <QrCodeWrap />;
}
